let LangZh = {
  ProductBand: '捍卫者文件流转系统',
  haTakeover: '备机接管运行，尽快检查修复主机',
  dashboard: {
    totalInvokeNum: '总页面浏览量(PV)',
    weekRate: '周环比',
    dayRate: '日环比',
    yesterdayInvoke: '昨日页面浏览量(PV)',
    totalUV: '登录人数',
    yesterdayUV: '昨日登录人数',
    totalMatterNum: '总文件数',
    yesterdayMatterNum: '昨日文件数',
    totalFileSize: '文件总大小',
    yesterdayMatterSize: '昨日文件大小',
    recentDayInvokeUV: '最近{}日页面访问量/登录人数',
    downloadMatterTop10: '文件下载量TOP10',
    activeIpTop10: '活跃IP TOP10',
    loading: '加载中…',
    date: '日期',
    num: '数量',
    yesterday:'昨',
    warnHint: '如果需要可以手工刷新',
    reRun: '刷新',
    availableDiskSpace: '硬盘可用空间',
    cpuUsage: 'CPU占用率',
    storageUsage: '存储占用率',
    totalMemory: '内存总数',
    systemStatus: '系统状态监控',
    memory:'内存占用率',
    storage:'磁盘占用率',
    usageStats:'访问统计',
    storageInfo:'存储信息'
  },
  systemLog: {
    // 标题与字段
    title: '系统日志',
    module: '模块',
    operation: '操作',
    user: '操作用户',
    targetType: '目标类型',
    targetName: '目标名称',
    detail: '操作详情',
    ip: 'IP地址',
    createTime: '发生时间',
    logType: '日志类型',
    alarmLevel: '报警级别',
    extraData: '扩展数据',
    keyword: '关键字',
    keywordPlaceholder: '用户名、目标名称、详情等',
    unknownUser: '未知用户',
    unknownTarget: '未知目标',
    usernamePlaceholder:'填写用户名',
    uuidNotSpecified: 'UUID未指定，无法获取到详情！',
    viewDetail: "查看详情",
    basicInfo: "基本信息",
    changeDetails: "变更详情",

    close: "关闭",
   // --- 新增操作 ---
   operationBatchCreate: '批量创建',
   operationBatchDelete: '批量删除',
   operationBatchUpdate: '批量更新',
   operationTransfiguration: '转换',
   operationScan: '扫描',
   operationSync: '同步',
   operationExecute: '执行',
    // 模块
    moduleAuth: '认证管理',
    moduleUser: '用户管理',
    moduleDepartment: '部门管理',
    moduleSpace: '空间管理',
    moduleSystem: '系统设置',
    moduleRole: '角色权限',
    moduleLog: '日志管理',
    moduleBackup: '备份恢复',
    moduleAlarm: '告警管理',
  
    // 操作类型
    operationLogin: '登录',
    operationLogout: '登出',
    operationLoginFailed: '登录失败',
    operationCreate: '创建',
    operationUpdate: '更新',
    operationDelete: '删除',
    operationEnable: '启用',
    operationDisable: '禁用',
    operationResetPassword: '重置密码',
    operationChangePassword: '修改密码',
    operationImport: '导入',
    operationExport: '导出',
    operationBackup: '备份',
    operationRestore: '恢复',
    operationClean: '清理',
    operationConfigUpdate: '配置更新',
    operationRoleAssign: '分配角色',
    operationPermissionGrant: '授权',
    operationPermissionRevoke: '撤销权限',
  
    // 目标类型
    targetTypeUser: '用户',
    targetTypeDepartment: '部门',
    targetTypeSpace: '空间',
    targetTypeSpaceMember:'空间成员',
    targetTypeShare:'共享',
    targetTypeSystem: '系统',
    targetTypeRole: '角色',
    targetTypeLog: '日志',
    targetTypeBackup: '备份',
    targetTypeSetting: '设置',
    targetTypeSystemTask:'系统任务',
    // 日志类型
    logTypeNormal: '普通',
    logTypeWarning: '警告',
    logTypeError: '错误',
    logTypeSecurity: '安全',
  
    // 报警级别
    alarmLevelNone: '无',
    alarmLevelWarning: '警告',
    alarmLevelError: '错误',
    alarmLevelCritical: '严重',
  
    // 操作按钮
    export: '导出',
    clean: '清理',
    statistics: '统计',
    refresh: '刷新',
    advancedFilter: '高级筛选',
    timeRange: '时间范围',
    selectModule: '选择模块',
    selectOperation: '选择操作',
    selectTargetType: '选择目标类型',
    selectLogType: '选择日志类型',
    selectAlarmLevel: '选择报警级别',
    search: '搜索',
    reset: '重置',
  
    // 统计相关
    statisticsTitle: '统计信息',
    statisticsTotalOperations: '总操作数',
    statisticsWarningCount: '警告数量',
    statisticsErrorCount: '错误数量',
    statisticsPeriod: '统计周期',
    statisticsRecentAlarms: '近期告警',
    statisticsModuleStats: '模块统计',
  
    // 导出相关
    exportSuccess: '导出成功',
    exportFailed: '导出失败',
    exportConfirm: '确认要导出系统日志吗？',
  
    // 清理相关
    cleanSuccess: '清理成功',
    cleanFailed: '清理失败',
    cleanConfirm: '确认要清理{keepDays}天前的系统日志吗？',
    cleanKeepDays: '保留天数',
    moduleShare: "分享模块",
moduleSync: "同步模块",
moduleOther: "其他模块",
moduleFile: "文件模块",
moduleSecurity: "安全模块",
moduleStorage: "存储模块"
  },
  install: {
    selectDeploy: '部署方式',
    fastDeploy: '快速部署',
    stepDeploy: '分步部署',
    configMysql: '配置数据库',
    dbType: '数据库类型',
    port: '端口',
    schema: '库名',
    username: '用户名',
    password: '密码',
    charset: '编码',
    mysqlConnectionPass: 'MySQL连接测试通过',
    testMysqlConnection: '测试MySQL连接',
    notice: '注意',
    sqliteNotice1: 'sqlite是一个轻量的文件数据库，无需安装即可使用',
    mysqlNotice1:
      '如果数据库和本系统安装在同一台服务器，Host可以直接填写 127.0.0.1。',
    mysqlNotice2:
      '数据库账户的权限要求要能够创建表，否则第二步"创建表"操作会出错',
    validateMysqlFirst: '请首先验证数据库连接',
    fastDeplyNotice: '快速部署目前仅支持sqlite数据',
    preStep: '上一步',
    nextStep: '下一步',
    createTable: '创建表',
    installed: '已安装',
    installedButMissing: '已安装,字段缺失',
    toBeInstalled: '待安装',
    allFields: '所有字段',
    missingFields: '缺失字段',
    tableNotice: '点击"一键建表"后会按照以下逻辑执行操作：',
    tableNotice1: '如果某表不存在，则直接创建表。',
    tableNotice2: '如果某表存在并且字段齐全，那么不会对该表做任何操作。',
    tableNotice3: '如果某表存在但是部分字段缺失，那么会在该表中增加缺失字段。',
    tableNotice4:
      '如果表中有多余的字段(多余字段即不是需要的字段)，不会做删除处理，而会维持原样。',
    oneKeyCreate: '一键建表',
    createFinish: '建表完成',
    createTableSuccess: '建表成功',
    crateTableFirst: "请首先点击'一键建表'",
    setAdministrator: '设置管理员',
    detectAdministrator: '检测到系统中已经存在有以下管理员：',
    useOrCreateAdministrator:
      '你可以使用其中一位管理员的用户名和密码进行验证，或者创建一位新的管理员账户',
    validateAdministrator: '验证管理员账户',
    createAdministrator: '创建管理员账户',
    administratorUsername: '管理员用户名',
    administratorPassword: '管理员密码',
    administratorRePassword: '再次输入密码',
    usernameRule: '由于用户名将作为文件上传的目录，因此只允许字母数字以及"_"。',
    congratulationInstall: '恭喜，安装成功！',
    configAdminFirst: '请首先配置管理员信息！',
    createAdminSuccess: '创建管理员成功(默认：admin/HWZ@1234)！',
    validateAdminSuccess: '验证管理员成功！',
    pressToHome: '点击下方按钮来完成安装过程并进入首页。',
    enterHome: '完成，并进入首页',
    finish: '完成',
  },
  log: {   
    title: '操作日志',
    operation: '操作类型',
    target: '操作目标',
    user: '操作用户',
    space: '所属空间',
    detail: '操作详情',
    ip: 'IP地址',
    createTime: '操作时间',
    searchPlaceholder: '搜索日志...',
    allOperations: '全部操作',
    objectName:'目标名',
    upload: '上传',
    delete: '删除',
    softDelete: '软删除',
    recovery: '恢复',
    download: '下载',
    rename: '重命名',
    move: '移动',
    copy: '复制',
    createDirectory: '创建目录',
    upload_blocked:'上传阻断',
    download_blocked:'下载阻断',
    change_privacy: '修改文件隐私',
    outsend_apply: '外发申请',
    approval: '审批',
    forward: '转发',
    uploadskip:'上传跳过',
    syncskip:'上传跳过',
    // 文件同步相关操作
    sync_success: '同步成功',
    sync_failed: '同步失败',
    sync_received: '同步接收',
    outsend_sync_success: '外发同步成功',
    outsend_sync_failed: '外发同步失败',
    export: '导出', 
    clean: '清理', 
    cleanConfirm: '确认要清理{keepDays}天前的系统日志吗？', 
    cleanSuccess: '清理成功', 
    cleanFailed: '清理失败', 
    // 分享相关操作类型
    set_public_readonly: '设置只读公共分享',
    set_public_full: '设置完全公共分享',
    set_private_readonly: '设置只读私有分享',
    set_private_full: '设置完全私有分享',
    remove_share: '取消分享',
    preview_share_file: '预览文件',
  
    // 分享查看相关操作类型
    view_public_share_detail: '查看公开分享详情',
    view_private_share_owner: '查看私有分享（创建者）',
    view_private_share_target: '查看私有分享（被分享者）',
    view_my_shares: '查看我的分享',
    view_shares_shared_to_me: '查看分享给我的内容',
    browse_share: '浏览分享内容',
    download_share_zip: '下载分享压缩包',
    browse_share_files: '浏览分享文件列表',
    download_share_file: '下载分享文件',
    matter: '文件',
    directory: '目录',
    
    // 新增的本地日志和移动盘日志相关翻译
    localLogs: '本地日志',
    removableLogs: '移动盘日志',
    removableDevice: '移动存储设备',
    usbDevice: 'USB设备',
    hardDisk: '移动硬盘',
    solidStateDisk: '固态硬盘',
    sdCard: 'SD卡',
    mobileDevice: '移动设备',
    unknownDevice: '未知设备',
    deviceInfo: '设备信息',
  },
  layout: {
    allFiles: '个人空间', 
    myShare: '我的分享',
    bin: '回收站',
    setting: '系统设置',
    managementPage:'管理后台',
    FilesCirculation:'文件流转',
    PCSecPage:'终端安全管理',
    dashboard: '系统概况',
    users: '用户管理',
    logout: '退出登录',
    about: '关于',
    install: '安装系统',
    dragMouseUp: '可以松手啦~',
    space: '共享分组',
    fileslog: '文件日志',
    systemlog: '系统日志',
    removableLogs: '可移动存储日志',
    onlinePC: '主机列表',
    departments: '部门管理',
    removableFileBrowser: '可移动磁盘',
    onlineUsers: '在线用户',
  },
  member: {
    // 新增搜索相关
    searchUsername: '搜索用户名',
    selectRole: '选择角色',
    filterRole: '按角色过滤',
    showDeptMembersOnly: '仅显示部门成员',
    roleDistribution: '角色分布',
    memberStatistics:'成员统计',
    // 表格相关
    memberAvatar: '头像',
    memberUsername: '用户名',
    memberDepartment: '部门',
    memberRole: '成员角色',
    memberSource: '来源',
    memberCreateTime: '创建时间',
    memberOperation: '操作',
    memberCurrentUser: '当前用户',
    memberFromDepartment: '来自部门',
    memberTooltipManual: '手动添加',
    memberEdit: '编辑',
    memberUnbind: '解除绑定',
      // 删除部门成员确认
  deleteDeptMemberConfirm: '确认删除部门成员？',
  deleteDeptMemberWarning: '删除部门成员后将不再自动同步到该空间',
  
  // 成员管理相关提示
  willNotAutoAddAgain: '删除后不会再次自动添加',


  canManuallyReadd: '如需再次添加，请手动操作',
  deptSyncWillSkip: '部门同步时将跳过已删除的成员',
  syncWillNotReadd: '同步操作不会重新添加已删除的成员',
    // 统计相关
    totalMembers: '总成员数',
    deptMembers: '部门成员',
    manualMembers: '手动添加',

    // 新增定义 - 修改为固定文本
    memberFromDepartmentWithName: '来自部门',
  },
  department: {
    // 通用
    id: '部门ID',
    deptNo: '部门编号',
    shortName: '部门简称',
    fullName: '部门全称',
    type: '部门类型',
    orderIndex: '排序索引',
    orderNo: '排序号',
    parentDept: '父部门',
    parentName: '父部门名称',
    topLevel: '顶级部门',
    selectParentDept: '选择父部门',
    selectType: '选择部门类型',
    selectStatus: '选择状态',
    remark: '备注',
    noParentDept:'没有可用父部门',
    // 用户信息
    createUser: '创建人',
    updateUser: '更新人',
    
    // 表单验证
    idRequired: '部门ID不能为空',
    shortNameRequired: '请输入部门简称',
    fullNameRequired: '请输入部门全称',
    typeRequired: '请选择部门类型',
    orderIndexRequired: '请输入排序索引',
    orderIndexMin: '排序索引不能为负数',
    shortNameMaxLength: '部门简称最多50个字符',
    fullNameMaxLength: '部门全称最多100个字符',
    orderIndexRange: '排序索引必须在0-9999之间',
    
    // 占位符
    deptNoPlaceholder: '请输入部门编号',
    shortNamePlaceholder: '请输入部门简称',
    fullNamePlaceholder: '请输入部门全称',
    remarkPlaceholder: '请输入备注',
    // 部门相关
parentNodeHint: '提示：可以选择父节点（如总部、技术部），系统会自动包含其下所有子部门的用户',
parentNode: '父节点',
selectAll: '全选',
clearAll: '清空',
expandAllDepts: '展开所有部门',
expandAllDeptsDesc: '默认展开所有部门节点，方便选择',
parentNodeImportantHint: '重要提示：选择父节点将同时选择其所有子节点',
selectDepartmentsCount: '已选择 {0} 个部门',
totalAffectedDepts: '共 {0} 个部门将受到影响',
deptIdFormat: '部门 {0}',

// 批量操作相关
confirmBatchUpdateRole: '确定要将所选部门的所有成员角色更新为"{0}"吗？',
confirmRemoveDept: '确定要移除该部门的绑定吗？',
syncComplete: '同步完成',
batchAddDeptSuccess: '批量添加成功',
partialSuccess: '部分成功',
deptAddSuccessLog: '部门添加成功',
deptAddFailLog: '部门添加失败',
andMoreDepts: '...及其他部门',
boundDeptCount: '已绑定 {0} 个部门',
    // 操作 - 修改为固定文本
    createDept: '新建部门',
    editDept: '编辑部门',
    viewDept: '查看部门',
    deleteDept: '删除部门',
    deleteHint: '确定删除部门吗？',
    deleteConfirm: '删除后无法恢复，请谨慎操作',
    batchDelete: '批量删除',
    batchDeleteConfirm: '确定删除选中的部门吗？',
    selectDelete: '请先选择要删除的部门',
    batchAddConfirm:  '确定添加选中的部门吗？',

    // 类型
    company: '组织',
    department: '部门',
    team: '团队',
    
    // 状态
    enabled: '启用',
    disabled: '禁用',
    
    // 搜索
    search: '部门查询',
    searchHint: '可按部门名称、部门简称搜索',
    deptNoSearch: '部门编号',
    nameSearch: '部门名称',
    shortNameSearch: '部门简称',
    typeSearch: '部门类型',
    statusSearch: '状态',
    
    // 表格列
    operation: '操作',
    status: '状态',
    createTime: '创建时间',
    updateTime: '更新时间',

    // 树形操作
    expandAll: '展开全部',
    collapseAll: '折叠全部',
    
    // 成功消息
    createSuccess: '部门创建成功',
    updateSuccess: '部门更新成功',
    deleteSuccess: '部门删除成功',
    
    // 错误消息
    nameExists: '部门名称已存在',
    shortNameExists: '部门简称已存在',
    parentDeptNotExists: '父部门不存在',
    deptHasChildren: '部门下存在子部门，无法删除',
    deptHasUsers: '部门下存在用户，无法删除',
    circularReference: '不能将部门设置为自己的子部门',
    
    // 层级
    level: '层级',
    
    // 其他
    totalCount: '总部门数',
    rootCount: '根部门数',
    companyCount: '组织数',
    deptCount: '部门数',
    teamCount: '团队数',
    statistics: '部门统计',
    
    // 新增内容 - 修改为固定文本
    idFormat: '部门',
    boundDepartments: '已绑定部门',
    syncMembers: '同步成员',
    batchSetRole: '批量设置角色',
    noBoundDepartments: '未绑定任何部门',
    selectedDepartmentsCount: '已选择部门',
    batchAddByDept: '按部门批量添加',
    batchAddDeptHint: '选择要添加的部门，系统会自动将该部门下的所有用户添加到当前空间',
    selectDepts: '选择部门（可多选）',
    manualAdd: '手动添加',
    manual: '手动',
    batchAdd: '批量添加',
    addByDept: '按部门添加',

    addDeptMembers: '添加所选部门下的所有用户',
    skipExistingMembers: '跳过已存在的成员',
    setDefaultRole: '设置默认角色为"成员"',
    autoProcess: '系统将自动',
    partialAddSuccess: '部分添加成功',
    noUsersInDept: '所选部门中没有用户',
    noDeptBound: '当前空间未绑定任何部门',
    syncDeptMembers: '同步部门成员',
    confirmSyncDeptMembers: '确定要重新同步已绑定部门的成员吗？',
    willProcess: '系统将',
    addNewDeptUsers: '重新添加部门中新加入的用户',
    removeLeftUsers: '删除已离职的用户',
    keepOriginalSettings: '保留原有成员的设置',
    startSync: '开始同步',

    memberStatusUpToDate: '成员状态已是最新，无需同步',
    removeDeptBinding: '移除部门绑定',

    afterRemove: '移除后',
    noAutoSync: '不再自动同步该部门的成员',
    existingMembersNotDeleted: '已添加的成员不会被删除',
    canRebindLater: '可随时重新绑定该部门',
    deptBindingRemoved: '部门绑定已移除',
    batchUpdateDeptRole: '批量更新部门成员角色',
    confirmUpdateRole: '确定要将所选部门的所有成员角色更新吗？',
    roleUpdateWarning: '此操作会覆盖现有部门成员的现有角色设置，请谨慎操作！',
    partialUpdateSuccess: '部分更新成功',
    bindMemberConfirm: '确定添加选中的部门吗？',
    batchUpdateTitle: '批量更新部门成员角色',
    batchUpdateSelectDepartment: '选择要更新角色的部门：',
    batchUpdateSelectRole: '选择要设置的角色：',
    batchUpdateSelectedDepartments: '已选择部门',
    batchUpdateSelectedDepartmentsDesc: '这些部门下的所有成员角色将被更新',
    batchUpdateNote: '注意',
    batchUpdateNoteDesc: '此操作将覆盖所有选中部门成员的现有角色设置',
    batchUpdateOkText: '批量更新',
    
    // 新增搜索相关
    filterByDept: '按部门过滤',
    selectDept: '选择部门',

    // 补充缺失的字段 - 修改为固定文本
    selectFirst: '请先选择要添加的部门',
    noDeptToAdd: '没有部门需要添加',
    syncAffectedDepts: '将影响以下部门：',
    syncWarning: '此操作会同步所有已绑定部门的成员，可能会影响大量用户',
    syncDeptMembersFail: '同步部门成员失败:',
    removeDeptBindingFail: '移除部门绑定失败:',
    batchUpdateRoleFail: '批量更新角色失败:',

    addMode: '添加模式',
    includeSubDepts: '包含子部门',
    excludeSubDepts: '仅选中部门',
    includeSubDeptsDesc: '添加选中部门及其所有子部门',
    excludeSubDeptsDesc: '只添加选中的部门，不包含子部门',
    subDeptsHint: '子部门处理',
    subDeptsHintDesc: '系统会自动包含选中部门的所有子部门，无需手动选择',
    batchAddProcessNote: '处理说明',
    eachDeptIndependent: '每个部门独立处理',
    circularDependency: '发现循环依赖关系，请检查部门层级',
    // 新增

    totalCreated: '共创建空间',
    willBatchCreateForDepts: '将为选中的部门批量创建空间',
    readyToImport: '准备导入 {0} 条记录',
    import: '导入部门',
    export: '导出部门',
    exportExcel: '导出为Excel',
    exportJSON: '导出为JSON',
    exportSuccess: '成功导出 {0} 条部门数据',
    exportEmpty: '没有部门数据可以导出',
    importTitle: '导入部门配置',
    importTips: '请上传CSV或JSON格式的部门数据文件，支持更新现有部门数据',
    uploadFile: '上传文件',
    selectFile: '选择文件',
    supportedFormats: '支持格式：CSV, JSON',
    importOptions: '导入选项',
    updateExisting: '更新已存在的部门',
    keepRelations: '保持部门间关系',
    skipErrors: '跳过错误继续导入',
    importProgress: '导入进度',
    startImport: '开始导入',
    importing: '正在导入...',
    fileUploadSuccess: '文件上传成功',
    fileReadError: '文件读取失败',
    csvFormatError: 'CSV格式错误',
    jsonFormatError: 'JSON格式错误',
    unsupportedFormat: '不支持的文件格式',
    emptyData: '导入数据为空',
    missingRequiredField: '第 {0} 行缺少必需字段：{1}',
    invalidType: '第 {0} 行部门类型无效：{1}',
    invalidStatus: '第 {0} 行状态值无效：{1}',
    duplicateCode: '部门简称重复：{0}',
    dataValid: '数据验证通过，共 {0} 条记录',
    fileReady: '文件准备就绪，共 {0} 条记录',
    startingImport: '开始导入部门数据...',
    importingDept: '正在导入部门：{0} ({1}/{2})',
    importComplete: '导入完成！成功 {0} 条，失败 {1} 条',
    importSuccess: '成功导入 {0} 条部门数据',
    importFailed: '部门导入失败',
    importWithErrors: '导入完成，成功 {0} 条，失败 {1} 条',
    importError: '部门 {0} 导入失败：{1}',
    noImportData: '没有要导入的数据',
    templateFormat: '模板格式说明',
    fieldName: '字段名称',
    fieldKey: '字段标识',
    required: '必填',
    example: '示例',
    description: '说明',
    parentCode: '上级部门代码',
    parentCodeDesc: '填写上级部门的简称，用于建立部门间层级关系',

    orderIndexDesc: '数字越小排序越靠前',
    downloadTemplate: '下载模板',
    templateDownloadSuccess: '模板下载成功',
  },
  // 成功消息
  operations: {
    success: '操作成功',
    uploadSuccess: '上传成功',
    downloadSuccess: '下载成功',
    deleteSuccess: '删除成功',
    renameSuccess: '重命名成功',
    moveSuccess: '移动成功',
    copySuccess: '复制成功',
    shareSuccess: '分享成功',
    saveSuccess: '保存成功',
    createSuccess: '创建成功',
    updateSuccess: '更新成功',
    // 新增批量操作相关
    batchAddSuccess: '批量添加成功',
    batchUpdateSuccess: '批量更新成功',
    syncSuccess: '同步成功',
  },
  matter: {
    print: "打印",
    downloading: "下载中...",
    printing: "打印中...",
    downloadStarted: "文件下载已开始",
    downloadFailed: "文件下载失败",
    printFailed: "文件打印失败",
    printNotSupported: "该文件类型不支持直接打印",
    pdfPrintHint: "PDF文件已在新窗口打开，请使用浏览器的打印功能(Ctrl+P)",
    cadPrintHint: "CAD图纸打印功能需要使用专门的CAD软件，建议下载后使用专业软件打印",
    mindMapPrintHint: "思维导图打印功能建议下载后使用专业思维导图软件打印",
    printPopupBlocked: "打印窗口被阻止，请允许弹出窗口",
    noDownloadPermission: "您没有下载此文件的权限",
    noPrintPermission: "您没有打印此文件的权限",

    file: '文件',
    directoryDragNotSupported: '浏览器不支持目录拖拽上传',
    uploadError: '上传失败',
    partialUploadSuccess: '成功上传文件',
    directory: '文件夹',
    rename: '重命名',
    download: '下载',
    delete: '删除',
    hardDelete: '彻底删除',
    recovery: '恢复',
    more: '更多',
    share: '分享',
    close: '关闭',
    size: '大小',
    preview: '预览',
    move: '移动',
    moveTo: '移动到',
    upload: '上传',
    create: '新建',
    createTime: '创建时间',
    updateTime: '修改时间',
    deleteTime: '删除时间',
    uploadUserNickname: '上传者',
    root: '根目录',
    fillInPicLink: '请填写图片链接',
    rePick: '重新选择',
    unknown: "未知状态",
    chooseImage: '选择图片',
    uploadMode: '上传模式',
    approvalMode: '审批模式',
    normalMode: '正常模式',
    toapprovalMode: '<-点击切换审批模式',
    tonormalMode: '<-点击普通审批模式',
    exportAudit:'外发申请',
    selectFileFirst:'请先选择文件',
    fillMode: '填写模式',
    sizeExceedLimit: '文件大小超过了限制',
    dropNotDirectory: '不可拖拽文件夹进行上传',
    setPublic: '设置为公有文件',
    setPrivate: '设置为私有文件',
    copyLink: '复制下载链接',
    enterName: '请输入名称',
    publicFileEveryoneCanVisit: '公有文件，任何人可以访问',
    fileDetail: '文件详情',
    expire: '有效期',
    copyLinkAndCode: '复制链接+提取码',
    uploaded: '已上传',
    uploadDir: '上传文件夹',
    uploadDirTooltip: '上传整个文件夹及其子文件夹结构',
    uploadInfo: '上传信息',
    uploadErrorInfo: '部分文件上传失败，可导出csv文件查看',
    exportCSV: '导出上传错误详情',
    speed: '速度',
    fileInfo: '文件基本信息',
    fileName: '文件名',
    path: '路径',
    copyPath: '复制路径',
    publicOrPrivate: '文件公开性',
    privateInfo: '私有文件，只有自己或者授权的用户可以下载',
    publicInfo: '公有文件，任何人可以通过链接下载',
    downloadTimes: '下载次数',
    operations: '操作',
    approval: '审批',
    noneedApproval: '不需审批',
    waitApproval: '待审批',
    approvalPass: '审批通过',
    approvalReject: '审批拒绝',
    oneTimeLink: '一次性链接',
    oneTimeLinkInfo:
      '使用一次性链接下载后链接立即失效,可以分享这个链接给朋友，点击复制',
    imageCache: '图片缓存',
    searchFile: '搜索文件',
    noContentYet: '该目录下暂无任何内容',
    allFiles: '全部文件',
    newDirectory: '新建文件夹',
    notChoose: '没有选择文件',
    exceed1000: '最多只能同时选取1000个文件',
    noImageCache: '暂无图片缓存数据',
    recycleBin: '回收站',
    deleted: '已删除',
    unCompatibleBrowser: '当前浏览器不支持，请切换浏览器尝试',
    canIUse: '查看当前浏览器是否支持，点击跳转',
    intoRecycleBin: '放入回收站',
    finishingTip: '后台文件处理中，请稍候...',
    scanning: '正在扫描目录...',
    preparing: '正在扫描文件...',
    creatingDirs: '正在创建目录...',
    uploading: '正在上传',
    uploadedWithErrors: '上传完成，{0} 个文件失败',
    tooManyFilesWarn: '已发现 {0} 个文件，数量较多，建议使用拖拽方式上传或压缩为 ZIP 后上传。',
    crawl: '抓取文件',
    crawlLink: '链接',
    crawlLinkTip: '请输入链接',
    crawlFilename: '文件名',
    crawlFilenameTip: '请输入文件名',
    crawlBackground: '后台抓取',
    crawlSuccessTip: '抓取成功',
    crawlDescription:
      '抓取文件指后台将从指定资源链接直接下载到系统当前目录下',
    dragAlternative: '请使用右上角的"上传文件夹"按钮',
    approvalTitle:'文件操作审批',
    uploadApprovalStatus:'文件上传审批',
    outsendApprovalStatus:'文件外发审批',
    outsendPending:'未申请',
    type:'目标类型',
    operator:'操作者',
    approvalStatus:'审批状态',
    approvalRemark:'备注',
    approvalRemarkPlaceholder:'填写备注',
    reasonPlaceholder:'填写原因',
    reason:'原因',
    opsuccess:'操作成功',
    fullTextSearch: "全文检索",
    fullTextSearchChangeHint: '搜索模式已更改，请点击搜索按钮重新搜索',

    // 或者根据实际功能命名
    forwardToOtherSpace: '转发到其他空间',
    forwardFiles: '转发文件',
    listView:'列表',
    gridView:'缩略图',
    forward: '转发到个人空间',
    forwardConfirmTitle: '确认转发',
    forwardConfirmContent: '确定要将选中的文件/文件夹转发到您的个人空间吗？',
    forwarding: '正在转发...',
    forwardSuccess: '转发成功',
    forwardProgressTitle: '正在转发文件',
    forwardProgressContent: '正在复制第 {0} / {1} 个文件',
    forwardProgressCurrent: '当前文件：{0}',
    forwardProgressBytes: '已复制 {0} / {1}',
    forwardPartialFiles: '部分文件转发成功：成功 {0} 个，失败 {1} 个',

    // 错误提示
    forwardFailed: '转发失败',
    forwardNoFilesSelected: '请先选择要转发的文件或文件夹',

    // 语言文件中需要添加的键
    forwardToSpace: '转发到空间',
    forwardToSpaceHint: '将选中的文件从您的个人空间转发到目标用户的组空间',
    selectTargetUsersForSpace: '选择目标用户（及其所在空间）',
    selectUserPlaceholderForSpace: '请搜索并选择目标用户',

    selectedFilesCount: '已选文件数',
    forwardProcess: '转发流程',
    forwardStep1: '选择目标用户（可多选）',
    forwardStep2: '系统会将文件复制到目标用户的组空间中',
    forwardStep3: '目标用户可以在其组空间中查看和管理这些文件',
    selectedUsersCount: '已选用户',
    moreUsers: '更多', 
    forwardNoteTitle: '注意事项',
    forwardNote1: '文件将转发到目标用户所在的默认组空间',
    forwardNote2:'目标用户必须已加入至少一个组空间',
    forwardNote3: '转发后，您将失去对这些文件的控制权',
    forwardNote4: '转发操作不可撤销，请谨慎选择',

    deleteConfirmContent:'永久删除',
    forwardDescription: '将选中的文件从您的个人空间转发到目标共享空间',
    forwardInstructions: '转发说明',
    forwardDetails: '文件将被复制到目标空间的根目录，保留原始文件名。如果目标空间已存在同名文件，系统会自动添加后缀以避免覆盖。',
    forwardPartialSuccess: '部分空间转发成功：成功 {0} 个，失败 {1} 个',
    confirmForward: '确认转发',
    
    uploadPermissionHint: '只能转发到您有上传权限的空间（管理员、读写、上传预览角色）',
    
    selectTargetSpace: '请先选择要转发到的空间',
    selectTargetSpaceWithCount: '选择目标空间',
    
    loadedSpacesCount: '已加载空间',
    loadingSpaces: '正在加载空间列表...',
    
    noUploadPermissionSpaces: '您尚未加入任何有上传权限的共享空间',
    noMatchingSpace: '未找到匹配的空间',
    
    selectedSpacesCount: '已选空间',
    hasUploadPermission: '角色具有上传权限',
    
    // 其他可能需要的配置
    selectUserPlaceholder: '请搜索并选择目标用户',

    writePermissionSpacesHint: '仅显示您有写入权限（读写或管理员角色）的共享空间',
    noWritePermissionSpaces: '暂无有写入权限的空间',

    selectSpaceFirst: '请先选择要转发到的空间',
    selectTargetSpaces: '选择目标空间',
    selectSpacePlaceholder: '请搜索并选择目标空间',
    allSpaces: '全部空间',
    mySpaces: '我加入的空间',
    electedSpacesCount: '已选空间',

    previewFile: "预览文件",
    pdfText: "机密文件 - 禁止外传", 
    imageText: "图片预览",
    documentText: "文档预览",

    pdfToImage: 'PDF转图片',
    sourceFile: '源文件',
    imageFormat: '图片格式',
    storagePath: '存储路径',
    inputStoragePath: '请输入存储路径',
    storagePathTip: '转换后的图片将保存到指定路径',
    losslessCompression: '无损压缩',
    lossyCompression: '有损压缩',
    highQuality: '高质量',
    vectorImage: '矢量图',
    pleaseInputStoragePath: '请输入存储路径',
    pdfConvertSuccess: 'PDF转换成功',
    pdfConvertFailed: 'PDF转换失败',

    pdfConvertTip: '转换后的图片将下载到浏览器的默认下载目录',
    browse: '浏览',
    pleaseSelectStoragePath: '请选择存储目录',
    multiPageZipDownloaded: '多页PDF已转换为压缩包并开始下载',
    singlePageDownloaded: '单页PDF已转换为图片并开始下载',

    // 新增的状态和操作
    pending: '待审批',
    approved: '已通过',
    rejected: '已拒绝',
    draft: '草稿',
    normal: '正常',

    outsendApproved: '外发通过',
    outsendRejected: '外发拒绝',
    unknownStatus: '未知状态',

    confirmApproval: '确认审批',
    confirmApproveFile: '确定要审批文件吗？',
    confirmReject: '确认驳回',
    confirmRejectFile: '确定要驳回文件吗？',
    approvalOperation: '审批操作',
    chooseOperationForFile: '请选择对文件的操作',
    pass: '通过',
    reject: '驳回',

    approveSuccess: '文件审批通过',
    rejectSuccess: '文件已驳回',

    mobileApprovalTip: '点击"待审批"状态进行审批操作',
  },
  router: {
    allFiles: '全部文件',
    fileDetail: '文件详情',
    login: '登录',
    autoLogin: '自动登录',
    register: '注册',
    users: '用户列表',
    userDetail: '用户详情',
    changePassword: '修改密码',
    editUser: '编辑用户',
    createUser: '创建用户',
    shareDetail: '分享详情',
    myShare: '我的分享',
    dashboard: '系统概况',
    install: '安装平台',
    setting: '系统设置',
    fileslog:'文件日志',
  },
  preference: {
    /* ===== 原有字段保持不变 ===== */
    basic: '基本设置',
    preview: '预览设置',
    scan: '扫描磁盘(立即扫描为全局，自动可设置范围)',
    websiteName: '平台名称',
    pleaseEnterPlatformIp: '请输入 IP 地址',
    operationFailed: '操作失败',
    logo: 'Logo',
    syncGeneralTips: '目标服务器地址用于所有类型的同步操作，请确保填写正确的服务器地址',
    syncServerDescription: '请输入完整的服务器地址，例如: http://example.com:8010 或 http://192.168.1.8:8010',
    userSyncDescription: '同步本服务器所有用户到对方服务器',
    logoSquare: 'logo请使用正方形图片，否则在显示时会裁剪成正方形',
    onlyAllowIco: '只允许上传.ico图标',
    copyright: '版权信息(支持html)',
    extraInfo: '备案信息(支持html)',
    zipMaxNumLimit: '文件下载数量限制',
    zipMaxSizeLimit: '文件下载大小限制(B)',
    current: '当前值',
    noLimit: '无限制',
    userDefaultSizeLimit: '用户默认总大小限制(B) ',
    matterBinDefaultSaveDay: '回收站默认保留天数',
    enterMatterBinDefaultSaveDay: '默认回收站默认保留天数必填!',
    docLink: '文档链接',
    hwzDocLink: 'http://www.hanweizhe.net',
    allowRegister: '允许自主注册',
    antivirusEnabled: '开启上传杀毒(会导致上传变慢)',
    virusScanTimeout: '病毒扫描超时(秒)',
    virusScanTimeoutRange: '请输入30-3600之间的数字',
    second: '秒',
    systemCleanup: '重置系统',
    antivirusUpdate: '病毒库管理',
    manualUpdate: '手动升级病毒库',
    manualUpdateTip: '调用 freshclam 命令在线更新病毒库',
    uploadVirusDb: '内网上传病毒库',
    uploadPackage: '上传压缩包',
    uploadVirusDbTip: '上传病毒库压缩包（支持 .zip/.tar.gz），用于纯内网环境',
    virusDbUpdateSuccess: '病毒库更新成功',
    virusDbUpdateFailed: '病毒库更新失败，请检查系统日志',
    virusDbUploadSuccess: '病毒库上传并解压成功',
    virusDbUploadFailed: '病毒库上传失败，请检查文件格式',
    invalidVirusDbPackage: '无效的病毒库压缩包，请上传 .zip/.tar.gz 文件',
    systemCleanupDescription: '重置系统将清空除管理员账号外所有数据',
    systemCleanupPrompt: '重置系统将清空除管理员账号外所有数据，事关重大，请输入登录密码',
    previewConfig: '文件预览配置',
    editPreference: '设置系统参数',
    editPreviewEngine: '设置预览引擎',
    enterWebsiteName: '请输入平台名称!',
    enterZipMaxNumLimit: 'zip最大数量限制必填!',
    enterZipMaxSizeLimit: 'zip大小限制必填!',
    enterUserDefaultSizeLimit: '默认用户空间大小必填!',
    engine: '{}号预览引擎',
    noEngine: '暂无在线预览引擎配置',
    newEngine: '添加一个预览引擎',
    engineReg: '引擎格式',
    engineSuffix: '匹配后缀',
    enginePreview: '预览方式',
    defaultPreview: '默认引擎',
    previewEngine: '{}号引擎',
    defaultPreviewDesc: '默认预览引擎，不可移除',
    engineRegHelper: '此处填写模板语法：{url}表示文件路径，预览时会自动替换成对应的文件url；{b64url}表示base64机密后的路径，适用于kkfileview；',
    engineUsageHint: '对于一个文件的预览，使用第一个匹配到后缀名的引擎，没有配匹到则使用系统默认预览引擎',
    engineRegPlaceHolder: '例如：https://xxx.xxx.xxx?url={url}',
    engineSuffixPlaceHolder: '输入后缀，使用逗号分隔，不用带. 例如：doc,ppt,xls',
    previewCurrent: '本站预览',
    previewOpen: '新标签打开',
    editScan: '设置磁盘扫描',
    scanDisabledHint: '自动扫描已关闭，不会执行定时扫描任务',
    enableScan: '开启磁盘扫描',
    disabledScan: '暂未开启磁盘扫描',
    scanCron: '定时扫描',
    scanCronValidate: '定时扫描不能为空',
    cron: 'cron表达式',
    cronValidate: 'cron表达式不能为空',
    scanScope: '扫描范围',
    scanScopeValidate: '扫描范围不能为空',
    scanSpaces: '扫描空间',
    scanStatus: '自动扫描状态',
    enableScanDesc: '启后系统将按照设定的周期自动执行扫描',
    scanPerTenSeconds: '每十秒',
    scanPerThirtySeconds: '每三十秒',
    scanPerMinute: '每分钟',
    scanPerHour: '每小时',
    scanCustom: '自定义',
    chooseSpaces: '模糊搜索空间',
    chooseSpacesValidate: '请选择至少一个空间',
    scanLoading: '扫描中，请稍后...',
    matterBinDefaultTip: '设置0表示关闭回收站功能',
    scanImmediately: '立即扫描',
    fullTextSearchEnabled: '敏感字检查',
    sensitiveWords: '敏感字',
    scanProgress: '扫描进度',
    scanning: '正在扫描...',
    currentFile: '当前文件',
    close: '关闭',
    scanProgressFailed: '获取扫描进度失败',
    scanFailed: '扫描失败',
    scanStartFailed: '扫描启动失败',
    scanComplete: '扫描完成',
    totalFiles: '总文件数',
    processedFiles: '已处理文件',
    scanError: '扫描错误',
    manageSensitiveWords: '管理敏感字',
    enterSensitiveWord: '输入敏感字',
    noSensitiveWords: '暂无敏感字',
    noSensitiveWordsToExport: '没有敏感字可导出',
    sensitiveWordsImported: '成功导入敏感字',
    export: '导出',
    import: '导入',
    add: '添加',
    security: '安全设置',
    forbiddenKeywords: '禁止关键词',
    noForbiddenKeywords: '无禁止关键词',
    forbiddenExtensionsEnabled: '禁止文件类型',
    forbiddenExtensions: '扩展名设置:',
    manageForbiddenExtensions: '管理禁止扩展名',
    enterForbiddenExtension: '输入扩展名（不含点）',
    noForbiddenExtensions: '暂无禁止扩展名',
    noForbiddenExtensionsToExport: '没有禁止扩展名可导出',
    forbiddenExtensionsImported: '成功导入禁止扩展名',
    watermarkSet: '预览水印设置',
    watermarkEnabled: '预览水印',
    manageWatermark: '管理水印',
    enabled: '已启用',
    disabled: '已禁用',
    watermarkPreview: '水印预览',
    watermarkPreviewContent: '这是水印效果预览页面',
    watermarkText: '水印文本',
    enterWatermarkText: '请输入水印文本',
    watermarkFontSize: '字体大小',
    watermarkOpacity: '透明度',
    watermarkRotate: '旋转角度',
    watermarkColor: '水印颜色',
    showUsername: '显示用户名',
    fileTypeSpecific: '文件类型特定设置',
    pdfWatermarkText: 'PDF水印文本',
    enterPdfWatermarkText: '请输入PDF文件水印文本',
    imageWatermarkText: '图片水印文本',
    enterImageWatermarkText: '请输入图片文件水印文本',
    documentWatermarkText: '文档水印文本',
    enterDocumentWatermarkText: '请输入文档文件水印文本',
    previewWatermark: '预览水印效果',
    version: '版本号',
    dbType: '数据库类型',
    SyncSet: '同步设置',
    targetServerAddress: '目标服务器地址',
    targetServerAddressPlaceholder: '请输入目标服务器地址，如：http://192.168.1.100:8010',
    enterServerAddress: '请输入目标服务器地址',
    invalidServerAddressFormat: '服务器地址格式不正确，请以 http:// 或 https:// 开头',
    syncing: '同步中...',
    syncAllUsers: '同步所有用户',
    syncDescription: '将本地所有用户同步到目标服务器，同名用户会自动跳过',
    syncCompleted: '用户同步完成',
    syncFailed: '用户同步失败: ',
    autoSyncNewFilesHint: '开启同用户新增文件自动同步',
    syncOnlyApprovedFilesHint: '仅同步外发审批后文件',
    saveSettings: '保存设置',
    autoSyncNewFilesDescription: '用户上传的新文件将自动同步到目标服务器',
    syncOnlyApprovedFilesDescription: '只同步已通过外发审批流程的文件，保障数据安全',
    syncAllDepts: '同步所有部门',
    deptSyncDescription: '将目标服务器的部门数据同步到本系统',
    deptSync: '部门同步',
    userSync: '用户同步',
    autoSync: '自动同步',
    deptSyncTips: '部门同步会将本系统部门同步到目标服务器，包括部门层级关系',
    userSyncTips: '用户同步会将本系统用户同步到目标服务器',
    deptSyncConfirm: '确认同步部门',
    deptSyncConfirmContent: '此操作将从本系统获取部门数据并更新到目标服务器，是否继续？',
    deptSyncCompleted: '部门同步完成，成功 {0} 个，共 {1} 个',
    deptSyncFailed: '部门同步失败',
    userSyncCompleted: '用户同步完成',
    dailyAtMidnight: '每天0点',
    every6Hours: '每6小时',
    every12Hours: '每12小时',
    weeklyOnSunday: '每周日0点',
    pdfWatermarkColor: 'PDF水印颜色',
    imageWatermarkOpacity: '图片水印不透明度',
    customColorPlaceholder: '自定义颜色，格式: rgba(255,255,255,0.5)',
    invalidColorFormat: '请输入有效的颜色值，如: rgba(255,255,255,0.5)',
    defaultWatermarkText: '预览文件',
    defaultPdfWatermarkText: '机密文件 - 禁止外传',
    defaultImageWatermarkText: '图片预览',
    defaultDocumentWatermarkText: '文档预览',
    watermarkSavePartialSuccess: '基本设置保存成功，但水印配置保存失败',
    more: '更多',
    favicon: 'icon',
    currentCount: '当前数量',
    autoClean: '自动清理',
    cleanBeforeDays: '清理多少天前的文件',
    day: '天',
    autoCleanWarning: '自动清理警告',
    autoCleanWarningDesc: '此操作将自动清理符合条件的文件，清理后无法恢复，请谨慎设置。',
    autoCleanCaution: '请确保您了解此功能的影响，并谨慎设置清理天数。',
    autoCleanDesc: '开启后系统将自动清理指定天数前的文件(非摆渡环境不建议开启)',
    cleanBeforeDaysDesc: '将清理此天数之前的文件，例如设置为30天，则会清理30天前的文件。',
    autoCleanWarningDescText: '开启自动清理功能将永久删除指定天数前的文件。被删除的文件无法恢复，请谨慎操作！',
    basicSettings: '基础设置',
    advancedSettings: '高级设置',
    platformIpSettings: '平台 IP 地址',
    currentPlatformIp: '当前 IP 地址',
    newPlatformIp: '新 IP 地址',
    saveIp: '保存 IP',
    enterPlatformIp: '请输入 IP 地址',
    invalidIpFormat: 'IP 地址格式无效',
    updateIpFailed: '更新 IP 失败',
    fetchFailed: '获取失败',
    loading: '加载中...',
    notConfigured: '未配置',
    platformIpTips: '修改后将影响平台对外服务的访问地址，请谨慎操作。',
    advancedSettingsDisabled: '高级设置已禁用',
    advancedSettingsDisabledDesc: '当前系统配置下，扫描和同步功能不可用。',
    deptSyncCompletedGeneric: '部门同步完成',
    scanStarting: '正在启动扫描...',
    ipWithNetmask: 'IP地址/掩码',
    ipWithNetmaskPlaceholder: '例如 192.168.1.100/24 或 192.168.1.100（默认掩码24）',
    gateway: '网关地址',
    gatewayPlaceholder: '例如 192.168.1.1',
    dns: 'DNS 服务器',
    dnsPlaceholder: '多个用英文逗号分隔，如 8.8.8.8,114.114.114.114',
    invalidNetmask: '子网掩码必须是 1-32 之间的数字',
    invalidGateway: '网关 IP 地址格式无效',
    pleaseRevisitWithNewIp: '请使用新 IP 地址 {ip} 重新访问系统。',
    platformIpUpdated: 'IP 修改成功',
    resetSyslogTime: '重置上报时间',
    resetSyslogConfirmTitle: '重置上报时间点',
    resetSyslogConfirmContent: '重置后，转发器将从最近24小时的日志开始重新上报，可能导致重复数据。确定吗？',
    /* ===== 新增字段 ===== */
    securityAppSettings: '安全APP相关设置',
    forceAutoUpload: '强制自动上传',
    forceAutoUploadDesc: '客户端文件自动上传至服务器',
    appsecOnly: '仅允许加密环境APP登录',
    appsecOnlyDesc: '开启后，PC客户端登录必须携带加密环境标识，否则拒绝登录',
    uploadDirectories: '上传目录列表(桌面，只需填写"桌面")',
    addDirectory: '添加目录',
    noUploadDirectories: '暂无配置目录',
    enterDirectoryPath: '请输入目录路径',
    save: '保存',
    delete: '删除',
    fileTypes: "文件类型列表",
    addFileType: "添加类型",
    noFileTypes: "暂无配置类型",
    enterFileType: "请输入文件扩展名（例如 .txt）",
    fileTypeExists: "该文件类型已存在",
    syslogSettings: "Syslog 上报设置",
    syslogEnable: "启用上报",
    syslogServer: "Syslog 服务器地址",
    syslogServerPlaceholder: "例如: 192.168.1.100 或 syslog.example.com",
    syslogPort: "端口",
    syslogCron: "上报频率 (Cron)",
    syslogCronPlaceholder: "例如: */5 * * * * (每5分钟)",
    syslogBatchSize: "每次最多上报条数",
    syslogDescription: "启用后，本地审计日志将定期转换为标准 Syslog 格式并发送到指定服务器。",
    cascadeSettings: "级联设置",
    cascadeSettingsDesc: "配置上级服务器 IP 地址后，本平台可将数据级联上报至上级平台，或从上级平台同步配置。",
    upstreamServer: "上级服务器 IP",
    upstreamServerPlaceholder: "请输入上级服务器地址，例如：http://192.168.1.100:8010",
    upstreamServerTips: "留空表示无上级服务器。请确保输入的地址可访问，并包含协议（http:// 或 https://）及端口号。",
    systemUpgrade: "系统升级",
    systemUpgradeDesc: "上传前端升级包或客户端安装包，上传后即时生效（前端页面需刷新后加载新版）。",
    frontendUpgrade: "前端升级包",
    frontendUpgradeTip: "上传前端打包产物 (.zip)，包内应包含 index.html 与 static 目录，解压后将覆盖系统网页。",
    pcUpgrade: "PC 客户端升级",
    pcUpgradeTip: "上传 PC 客户端安装包 (.msi)，将保存为 html/APP/HWZWinApp.msi 并写入右侧填写的版本号；客户端将通过版本号判断是否需要升级。",
    pcVersionPlaceholder: "版本号（必填）",
    pcVersionRequired: "请先填写版本号，再上传 PC 客户端安装包",
    mobileUpgrade: "手机客户端升级",
    mobileUpgradeTip: "上传安卓客户端安装包 (.apk)，将保存为 html/APP/AndroidApp.apk。",
    choosePackage: "选择文件",
    invalidFrontendPackage: "无效的升级包，请上传 .zip 文件",
    invalidPcPackage: "无效的安装包，请上传 .msi 文件",
    invalidMobilePackage: "无效的安装包，请上传 .apk 文件",
    upgradeFrontendSuccess: "前端升级包上传并解压成功",
    upgradeFrontendFailed: "前端升级包上传失败",
    upgradePcSuccess: "PC 客户端升级包上传成功",
    upgradePcFailed: "PC 客户端升级包上传失败",
    upgradeMobileSuccess: "手机客户端升级包上传成功",
    upgradeMobileFailed: "手机客户端升级包上传失败",
    overallUpgrade: "整体升级",
    backupNow: "一键备份",
    backupLoading: "正在备份，请稍候…",
    backupRunning: "备份进行中",
    backupSuccess: "备份完成",
    backupFailed: "备份失败",
    backupDir: "备份目录",
    backupRecords: "备份记录",
    backupRefresh: "刷新",
    backupEmpty: "暂无备份记录，点击「一键备份」开始。",
    backupLoadFailed: "获取备份记录失败",
    backupConfirmTitle: "确认开始备份？",
    backupConfirmContent: "备份包含数据库、文件数据、配置与授权，耗时取决于数据量。备份期间请勿进行其他操作。",
    backupViewLog: "查看备份日志",
    backupClose: "关闭",
    overallStepBackup: "① 备份数据",
    overallStepUninstall: "③ 卸载旧版",
    overallStepInstall: "④ 安装新版并恢复",
    fullUpgradeStart: "上传安装包并开始整体升级",
    fullUpgradeStartDesc: "上传新版安装包 (.tar.gz)，系统将自动执行：备份 → 卸载旧版 → 安装新版(含 MySQL 重装) → 恢复数据。全部完成后提示重新访问网站验证；仅当失败时才需要登录服务器终端处理。",
    fullUpgradeRestoreDir: "恢复备份目录（可选）",
    fullUpgradeRestoreDirTip: "留空则自动使用最新备份，也可指定 /HwzDiskbak/hwzbak_* 目录",
    fullUpgradeInvalidPackage: "无效的升级包，请上传 .tar.gz 文件",
    fullUpgradeConfirmTitle: "确认开始整体升级？",
    fullUpgradeConfirmContent: "将依次自动执行：备份 → 卸载旧版 → 安装新版(含 MySQL 重装) → 恢复数据。升级期间服务会中断，页面将显示升级进度；完成后需重新访问网站验证。升级期间请勿关闭浏览器、保持网络稳定。",
    fullUpgradeStarted: "整体升级已启动",
    fullUpgradeStartFailed: "启动整体升级失败",
    fullUpgradeRunning: "整体升级进行中",
    fullUpgradeProgress: "升级进度",
    fullUpgradeLog: "升级日志",
    upgradeStateBackingUp: "正在备份数据...",
    upgradeStateUninstalling: "正在卸载旧版本...",
    upgradeStateInstalling: "正在安装新版与 MySQL，耗时较长...",
    upgradeStateRestoring: "正在恢复数据...",
    upgradeStateDone: "升级完成",
    upgradeStateFailed: "升级失败",
    upgradeRestarting: "服务重启中，请稍候...",
    upgradeDoneContent: "整体升级已完成，请重新访问 {0} 验证系统是否正常。",
    upgradeFailedContent: "整体升级失败，请登录服务器终端查看日志 /tmp/hwz_full_upgrade.log，手动完成升级后重新访问网站。",
    overallStepRestore: "④ 恢复数据",
    visitAgain: "重新访问",
    fullUpgradeUploading: "正在启动升级任务..."
  },

share: {
    shareDetail: '分享详情',
    shareTime: '分享时间',
    expireTime: '失效时间',
    noExpire: '永久有效',
    expired: '已过期',
    copyLinkAndCode: '复制链接+提取码',
    shareSuccess: '分享成功',
    sharer: '分享者',
    link: '链接',
    copyLink: '复制链接',
    code: '提取码',
    noValidFiles: '没有有效的文件可以分享',
    copyCode: '复制提取码',
    copySuccess: '复制成功',
    more: '更多',
    cancelShare: '取消分享',
    getLink: '获取链接',
    allFiles: '全部文件',
    noContent: '该目录下暂无任何内容',
    enterCode: '请输入提取码',
    getFiles: '提取文件',
    codeError: '提取码错误',
    cancelPrompt: '此操作将永久取消该分享, 是否继续?',
    hour: '1小时',
    day: '1天',
    week: '1周',
    month: '1个月',
    year: '1年',
    infinity: '永远有效',
    emptyHint: '暂无任何分享',
    myShareToOthers: '我分享给别人',
    othersShareToMe: '别人分享给我',
    sharedToMeEmptyHint: '暂无别人分享给你的文件',
    deleteConfirm: '确定要删除这个分享吗？',
    copyTip: "请复制下面的链接和提取码，分享给其他人",
    detail: '详情',
    createTime: '创建时间',
    downloadTimes: '下载次数',
    private: '私有分享',
    public: '公开分享',
    shareTo: '分享给',
    publicLink: '文件外链',
    privateShare: '指定用户分享',
    selectUsers: '选择用户',
    selectSpaces: '选择分组',
    selectUsersPlaceholder: '请选择要分享的用户',
    selectSpacesPlaceholder: '请选择要分享的分组',
    selectedTargets: '已选择分享对象',
    createPrivateShare: '创建私有分享',
    selectUserOrSpace: '请至少选择一个用户或分组',
    createSuccess: '分享创建成功',
    createFailed: '分享创建失败',
    publicSharePrompt: '创建公共分享链接，任何人通过链接和提取码都可以访问',
    createPublicShare: '创建公共分享',
    publicShareNotCreated: '请先创建公共分享',
    copyPublicSuccess: '公共分享链接和提取码已复制到剪贴板',
    permission: '权限设置',
    permissionView: '预览权限',
    permissionViewDesc: '仅允许查看和下载文件',
    permissionAll: '全部权限', 
    permissionAllDesc: '允许查看、下载、编辑和删除文件',
    shareLinkAndCode: "分享链接和提取码",
    copyLinkSuccess: "链接复制成功",
    copyCodeSuccess: "提取码复制成功", 
    copyLinkAndCodeSuccess: "链接和提取码复制成功",
    noPassword: "无密码",
    unknown: "未知",
    name: "分享名称",
    shareScope: "分享范围",
    privateShareDetail: "私有分享详情",
    targetUsers: "目标用户",
    targetSpaces: "目标空间",
    noTargetUsers: "未指定目标用户",
    noTargetSpaces: "未指定目标空间",
    noPermission: "无访问权限",
    clickToPreview: '点击预览',
    previewOnly: '仅限预览',
    previewOnlyNoDownload: '该分享设置为仅预览，无法下载文件',
    fullPermission: '完整权限',
    directPreview: '直接预览',
    isSharedToMe: '是否分享给我',
  },

  color: {
  grayTransparent: '灰色透明',
  redTransparent: '红色透明',
  blueTransparent: '蓝色透明',
  greenTransparent: '绿色透明',
  orangeTransparent: '橙色透明',
  purpleTransparent: '紫色透明',
  blackTransparent: '黑色透明',
  whiteTransparent: '白色透明'
},
user: {
  redirecting: '正在转跳...',
  oldPassword: '旧密码',
  newPassword: '新密码',
  confirmNewPassword: '确认新密码',
  cannotBeNull: '不能为空！',
  passwordNotSame: '两次输入不一致！',
  role: '角色',
  unknown: '未知用户',
  deptSelectWarning: '管理员选择部门，降级为部门管理员，仅有本部门用户管理权限！',
  adminDeptWarning: '内置超级用户为全局权限，禁止修改部门！',
  adminDeptChangeError: '内置超级用户为全局权限，禁止修改部门！',
  deptSelectHint: '管理员选择部门，降级为部门管理员，仅有本部门用户管理权限！',
  adminNoDept: '内置超级用户无部门限制',
  singleFileSizeLimit: '单文件限制',
  totalFileSizeLimit: '空间限制',
  usernamesearch: '按用户名搜索',
  current: '当前值',
  noLimit: '无限制',
  readWriteDesc: '可以上传、预览、下载和删除文件',
  uploadPreview: '上传预览权限',
  uploadPreviewDesc: '可以上传和预览文件，但不能下载',
  readOnly: '只读权限',
  readOnlyDesc: '只能下载和预览文件，不能上传、删除重命名等',
  userLimitTypeHint: '设置移动存储访问和操作权限(需配置移动存储模块)',
  totalFileSize: '已使用空间',
  webAllowedIpRange: "网页端IP范围",
  pcAllowedIpRange: "PC端IP范围",
  webIpRangeTip: "网页端允许登录的IP范围，支持CIDR格式，多个范围用逗号分隔，如：192.168.1.0/24,10.0.0.0/16",
  pcIpRangeTip: "PC端允许登录的IP范围，支持CIDR格式，多个范围用逗号分隔，如：192.168.1.0/24,10.0.0.0/16",
  status: '状态',
  lastLogin: '上次登录',
  lastLoginIp: '上次登录IP',
  lastLoginTime: '上次登录时间',
  resetPassword: '重置密码',
  transfiguration: '切换用户',
  changePassword: '修改密码',
  enterPassword: '输入密码',
  enterUsername: '请输入用户名',
  enterNewPassword: '请输入新密码',
  profile: '个人详情',
  avatar: '头像',
  username: '用户名',
  password: '密码',
  confirmPassword: '确认密码',
  disabled: '已禁用',
  disableUser: '禁用该用户',
  activeUser: '激活该用户',
  deleteUser: '删除该用户',
  deleteHint: '此操作将删除用户的所有记录，包括文件，分享，用户信息等内容，确定继续？',
  disable: '禁用',
  sync: '同步',
  active: '激活',
  loginSuccess: '登录成功',
  loginFailed: '登录失败',      // 新增
  welcomeLogin: '欢迎登录',
  logining: '正在登录...',
  login: '登录',
  currentuser: '当前用户',

  toToRegister: '立即注册',
  welcomeRegister: '欢迎注册',
  registering: '正在登录...',
  register: '注册',
  goToLogin: '前往登录',
  roleGuest: '游客',
  roleUser: '注册用户',
  roleUserRoleSpace: '用户空间角色',
  roleAdministrator: '管理员',
  roleAudit: '安全审计员',
  statusActive: '正常',
  statusDisabled: '禁用',
  webdavLink: 'WebDAV 地址',
  webdavHint: '使用您的登录用户名和密码通过 WebDAV 客户端（如 RaiDrive、Cyberduck）连接',
  docLink: '文档链接',
  createUser: '创建用户',
  editUser: '编辑用户',
  editSomebodyPassword: '修改用户的密码',
  transfigurationPromptText: '切换用户提示',
  transfigurationPrompt: '您将使用该用户的身份登录。请复制以下链接到其他浏览器访问，在当前浏览器访问会导致当前用户登录信息失效。',
  searchUser: '搜索用户',
  allowedDevices: "安全登录设置:",
  allowedDevicesHint: "设置登录类型的特征和范围(注：未设置类型限制登录)",
  webClient: "网页端", 
  pcClient: "PC端",  
  mobileClient: "移动端",  
  allowedIpRange: "允许登录的IP范围",  
  ipRangeTip: "支持CIDR格式，多个范围用逗号分隔，如：192.168.1.0/24,10.0.0.0/16",
  bindDeviceFeature: "绑定终端特征",

  downloadTemplate: '下载模板',
  templateDownloadSuccess: '模板下载成功',
  templateDownloadFailed: '模板下载失败',
  importCreateUsers: '导入批量创建',
  disableShare: '禁止分享/转发',
  shareSettings: '分享设置',
  setShare: "分享权限",
  shareEnabled: "允许分享",
  disableShareHint: '完全禁止用户进行任何形式的分享',
  disablePublicShare: '禁止公开分享',
  publicShareEnabled: '允许公开分享',
  disablePublicShareHint: '仅允许私有分享，禁止创建公开分享链接',
  publicShareEnabledHint: '允许私有分享与公开分享链接',
  batchCreateConfirm: '批量创建确认',
  willCreateUsers: '将批量创建用户',
  defaultPassword: '默认密码',
  batchCreateStart: '批量创建开始',
  batchCreateFailed: '批量创建失败',
  batchCreatePartial: '批量创建不完整',
  batchCreateSuccess: '批量创建成功',
  exportSuccess: '导出成功',
  department: '归属部门',
  selectDepartment: '选择部门',
  departmentId: '部门ID',
  webModeAgentHint: 'WEB模式开启，需要安装安全登录Agent',
  noDeptData: '暂无部门数据',
  noMatchingDept: '未找到匹配的部门',
  userLimitType: '移动盘权限',
  // 以下是新添加的字段
  bindWebFeature: "Web端特征绑定",
  bindPcFeature: "PC端特征绑定",
  bindWebFeatureTip: "网页端需要安装安全登录Agent",
  bindPcFeatureTip: "PC端需要安装安全登录Agent",
  noIpRangeSet: "未设置",
  
  onlineForceAutoUpload: '强制自动上传',
  onlineSend: '发送',
  onlineWebNoSupport: '当前用户非PCAPP客户端，不支持此功能',
  onlineforceLogout: '强制下线',
  onlineconfirmLogout: '确定要将该用户强制踢下线吗？',
  onlineloginTime: '登录时间',
  onlinedeviceInfo: '设备信息',
  onlinestatus: '状态',
  onlinestatusOnline: '在线',
  onlinestatusExpired: '已过期',
  onlinerefreshList: '刷新列表',
  onlinecurrentOnline: '当前在线',
  onlinepeople: '人',
   // 新增
   expirationDate: '授权截止日期',
   permanent: '永久',
   expiredTip: '账号已过期，请续期',
   expired: '已过期',
   selectExpirationDate:'请选择过期日期',
   expirationDateHint: '设置用户账号的有效期，到期后自动禁用。不设置表示永久用户。',
},
  space: {
    spaceName:'空间名',
    spaceNameSearch:'按空间名搜索',
    name: '共享分组',
    nameTip: '请输入分组名称，不可修改',
    create: '创建分组',
    editGroup: '修改分组',
    viewCard: '分块显示',
    viewList: '列表显示',
    totalSize: '已使用',
    sizeLimit: '单文件限制',
    sizeLimitTip: '请输入单文件大小限制',
    totalSizeLimit: '总大小限制',
    totalSizeLimitTip: '请输入总大小限制',
    leafNode: "叶子节点",
    nonLeafNode: "非叶子节点",
    pathLabel: "路径",
    unknown: '未知空间',
    refreshAndClose:"刷新并关闭",
    deleteHint:
      '此操作将永久删除该空间, 请先删除空间所有文件和空间成员, 是否继续?',
    memberManage: '分组成员管理',
    member: '分组成员',
    memberTip: '请搜索选择用户',
    memberRole: '成员角色',
    memberRoleTip: '请选择成员角色',
    bindMember: '绑定分组成员',
    unBindMember: '解绑分组成员',
    unBindMemberHint: '此操作将解绑该空间成员, 是否继续?',
    memberRoleReadonly: '只读',
    memberRoleReadWrite: '可读写',
    memberRoleAdmin: '管理员',
    emptyHint: '暂无任何空间',
    allSpaces: '全部空间',
    partialSpaces: '局部空间',
    memberRolePreviewOnly: '仅预览',
    memberRoleUploadPreview: '上传+预览',
    deleteDeptMemberWarningFull:'删除共享组成员',
    // 新增：成员管理相关
    memberManagement: '成员管理',
    // 成员统计相关
    memberStats: '成员统计',
    totalMembers: '总成员数',
    deptMembers: '部门成员',
    manualMembers: '手动添加',
    boundDepts: '绑定部门',
    deptMemberPercentage: '部门成员占比',
    // 同步相关
    syncMembers: '同步成员',
    batchSetRole: '批量设置角色',
    // 批量操作确认消息 - 修改为固定文本
    partialSuccess: '部分成功',
    syncFailed: '同步失败',
    // 部门绑定相关 - 修改为固定文本
    boundDepartmentsCount: '已绑定部门',
    batchAddByDept: '按部门批量添加',
    batchAddDeptHint: '选择要添加的部门，系统会自动将该部门下的所有用户添加到当前空间',
    // 角色设置
    setRole: '设置角色为：',
    alreadyExistsCount: '已存在',
    createdSuccess: '创建成功',
    alreadyExists: '已存在',
    batchCreateWithExists: '批量创建完成，成功创建 {0} 个空间，{1} 个部门已有空间',
    batchCreatePartialSuccess: '批量创建空间部分成功，成功创建 {0} 个，{1} 个已存在，{2} 个失败',
    // 绑定成员确认 - 修改为固定文本
    bindMemberConfirm: '确定添加选中的部门吗？',
        // 新增的角色描述字段
        memberRolePreviewOnlyDesc: '只能预览文件，不能上传或下载',
        memberRoleUploadPreviewDesc: '可以上传文件和预览文件',
        memberRoleReadonlyDesc: '只能查看文件，不能编辑',
        memberRoleReadWriteDesc: '可以查看和编辑文件',
        memberRoleAdminDesc: '空间管理员，拥有所有权限',
        batchCreate: '批量创建',
        batchCreateTitle: '批量创建空间',
        batchCreateHint: '批量创建说明',
        batchCreateDescription: '选择多个部门，系统会为每个选中的部门创建一个共享空间。可以根据需要设置空间的基础配置。',
        selectDepartments: '选择部门',
        selectDeptHint: '选择要创建空间的部门（可多选）',
        selectedDeptCount: '已选择部门',
        spaceConfigTemplate: '空间配置模板',
        leafNodeCount: "叶子节点: {0} 个",
        nonLeafNodeCount: "非叶子节点: {0} 个",
        nameTemplate: '空间名称模板',
        nameTemplatePlaceholder: '例如：{部门名称}共享空间，支持 {deptName} 占位符',
        nameTemplateHint: '提示：{deptName} 会被替换为部门名称',
        zipMaxSize: 'ZIP打包最大大小',
        enterZipMaxSize: '请输入ZIP打包最大大小',
        recycleKeepDays: '回收站保留天数',
        enterRecycleDays: '请输入回收站保留天数',
        batchCreatePreview: '批量创建预览',
        willCreateSpacesForDepts: '将为以下部门创建空间：',
        andMoreDepts: '及其他部门',
        batchCreateConfirm: '批量创建空间确认',
        batchCreateDeptCount: '将为选中的部门批量创建空间：',
        batchCreateConfig: '配置信息：',
        startBatchCreate: '开始批量创建',
        selectDeptForBatchCreate: '请选择要创建空间的部门',
        enterSpaceNameTemplate: '请输入空间名称模板',
        batchCreateSuccessAll: '批量创建成功',

        batchCreateAllFailed: '批量创建失败',
        batchCreateFailed: '批量创建失败',
        batchCreateError: '批量创建空间时发生错误',
        batchCreateResults: '批量创建结果',
        successCount: '成功',
        failedCount: '失败',
        success: '成功',
        failed: '失败',
        copySuffix: '（复制）',
        configCopied: '已复制空间配置',
        defaultSuffix: '共享空间',

        zipMaxNumLimit: 'ZIP打包最大文件数',
        enterSizeLimit: '请输入空间大小限制',
        enterZipMaxNum: '请输入ZIP打包最大文件数',
        autoGenerateNameHint: '空间名称将自动生成，格式为：部门名称 + 共享空间',
        autoGenerateNameDesc: '空间名称格式为：部门全称 + 部门简称 + 共享空间',
        membersAdded: '添加成员',
        membersSkipped: '跳过成员',
        autoAddMembersHint: '创建空间后将自动添加部门下的所有用户作为空间成员',
        autoAddMembersDesc: '系统将自动为部门下的所有用户添加空间成员权限，默认角色为只读',
          memberUnbind: '解除绑定',
  memberUnbindConfirm: '解除绑定成员',
  memberUnbindConfirmText: '确定要解除绑定该成员吗？',

  // 补充缺失的字段 - 修改为固定文本
  deptAddSuccessLog: '部门添加成功',
  deptAddFailLog: '部门添加失败',
  batchAddDeptSuccess: '批量添加成功',
  noMemberAdded: '操作完成，但未添加任何成员',
  batchAddFail: '批量添加失败:',
  deptBindingUpdated: '空间部门绑定已更新',
  memberUnbindConfirmDesc: '确定要解除此成员的绑定吗？',
  boundDeptCount: '已绑定部门',
  
  spaceBatchCreateSuccess: '批量创建空间成功',
  allDeptsHaveSpace: '所选部门已存在对应空间，无需重复创建',

  // 空间相关通用字段
  processRules: '处理规则',
  addAllUsersInDept: '添加每个部门下的所有用户',
  skipExistingMembers: '跳过已存在的成员',
  eachDeptIndependent: '每个部门独立处理，互不影响',
  selectedDepts: '选中部门',
  subDeptsToAdd: '子部门',
  totalDeptsToProcess: '总处理部门',

  addMode: '添加模式',
  confirmBatchAddDeptMembers: '确定按照以下配置批量添加部门成员吗？',
  startAdd: '开始添加',
  startSync: '开始同步',
  batchUpdate: '批量更新',
  batchAdd: '批量添加',
  // 共享分组配置导入导出
  exportConfig: '导出配置',
  importConfig: '导入配置',
  exportSuccess: '导出配置成功',
  exportFailed: '导出配置失败',
  exporting: '正在导出配置...',
  importConfirm: '确认导入共享分组配置？已存在的分组将跳过，不存在的分组将创建并绑定成员',
  importSuccess: '导入成功',
  importFailed: '导入失败',
  importResult: '导入完成：共 {0} 个分组，成功 {1} 个，跳过 {2} 个，新增成员 {3} 个',
  importConfigEmpty: '请选择或粘贴要导入的配置文件',
  importConfigInvalid: '导入配置格式错误，请检查 JSON 内容',
  importConfigPlaceholder: '粘贴导出的 JSON 配置内容，或点击上方按钮选择配置文件',
  selectImportFile: '选择配置文件',
  membersAddedCount: '新增成员 {0} 个',
  // 跨组检索
  crossGroupSearch: '检索',
  crossGroupSearchPlaceholder: '输入关键词，跨所有共享分组检索文件',
  crossGroupSearchTitle: '“{0}” 的跨组检索结果',
  crossGroupScopeHint: '当前范围：你加入的所有共享分组',
  crossGroupLoading: '正在检索中...',
  crossGroupEmpty: '未找到匹配的文件',
  crossGroupSearchFailed: '跨组检索失败',
  crossGroupKeywordEmpty: '请输入检索关键词',
  crossSearchGroupName: '所在分组',
  crossSearchSize: '大小',
  crossSearchDirectory: '文件夹',
  },
  model: {
    usernameRule: '用户名只能包含字母，数字和"_"',
    passwordRule: '密码长度至少为6位',
    linkCodeText: '链接:{} 提取码:{}',
    copyLinkCodeSuccess: '复制链接提取码成功',
  },
  error: {
    // 基础错误
    badRequest: '请求参数错误',
    needShareCode: '需要分享码',
    shareCodeError: '分享码错误',
    notLogin: '未登录',
    userDisabled: '用户已被禁用',
    unauthorized: '未授权访问',
    notFound: '资源不存在',
    methodNotAllowed: '请求方法不允许',
    conflict: '资源冲突',
    preconditionFailed: '前提条件失败',
    unsupportedMediaType: '不支持的媒体类型',
    rangeNotSatisfiable: '请求范围无法满足',
    notInstalled: '应用未安装',
    serverError: '服务器内部错误',
    unknownError: '服务器未知错误',
    networkError: '网络连接失败，请检查网络设置',
    clientError: '客户端错误：{}',
    
    // 操作相关错误
    operationFailed: '操作失败',
    uploadFailed: '上传失败',
    downloadFailed: '下载失败',
    deleteFailed: '删除失败',
    renameFailed: '重命名失败',
    moveFailed: '移动失败',
    copyFailed: '复制失败',
    shareFailed: '分享失败',
    previewFailed: '预览失败',
    
    // 文件相关错误
    fileNotFound: '文件不存在',
    fileSizeExceeded: '文件大小超过限制',
    fileTypeNotAllowed: '文件类型不允许',
    directoryNotEmpty: '目录不为空',
    
    // 空间相关错误
    spaceNotFound: '空间不存在',
    noSpacePermission: '无空间访问权限',
    spaceQuotaExceeded: '空间容量不足',
    
    // 用户相关错误
    userNotFound: '用户不存在',
    usernameExists: '用户名已存在',
    passwordIncorrect: '密码错误',
    passwordTooSimple: '密码过于简单',
    
    // 系统错误
    systemBusy: '系统繁忙，请稍后重试',
    databaseError: '数据库错误',
    configurationError: '配置错误',
    
    // 验证错误
    invalidInput: '输入内容无效',
    requiredField: '必填字段不能为空',
    invalidFormat: '格式不正确',
    outOfRange: '数值超出范围',
    
    // 会话错误
    sessionExpired: '会话已过期，请重新登录',
    tooManySessions: '会话数量达到上限',
    
    // 审批相关错误
    approvalPending: '审批待处理',
    approvalRejected: '审批被拒绝',
    approvalNotFound: '审批记录不存在',
    
    // 同步相关错误
    syncFailed: '同步失败',
    syncConflict: '同步冲突',
    
    // 外发相关错误
    outsendNotAllowed: '文件外发不允许',
    outsendApprovalRequired: '需要外发审批',
    
    // 部门相关错误
    deptNotFound: '部门不存在',
    deptIdRequired: '请选择部门',
    deptMemberStatError: '获取部门成员统计失败',
    deptBatchAddError: '批量添加部门成员失败',
    deptSyncError: '同步部门成员失败',
    deptBatchRemoveError: '批量移除部门成员失败',
    deptBatchUpdateRoleError: '批量更新部门成员角色失败',
    // 空间成员相关错误
    spaceMemberExist: '空间成员已存在',
    spaceMemberStatError: '获取空间成员统计失败',
    spaceMemberBatchAddError: '批量添加空间成员失败',
    spaceMemberSyncError: '同步空间成员失败',
    spaceMemberBatchRemoveError: '批量移除空间成员失败',
    spaceMemberBatchUpdateRoleError: '批量更新部门成员角色失败',

    conversionFailed: '转换记录失败',
    conversionNotSupported: '不支持的文件转换',
    conversionTimeout: '文件转换超时',
    conversionFormatError: '文件格式转换错误',
    
    // 新增错误
    spaceNameRequired: '空间名称不能为空',
    spaceSizeLimitRequired: '空间大小限制不能为空',


    spaceBatchCreatePartialSuccess: '批量创建空间部分成功',
    invalidRequestParams: '请求参数解析失败',
  },
  plugin: {
    cannotPreview: '无法预览',
    emptyHintDefault: '没有符合条件的项目',
    everyPage: '每页',
    items: '条',
    total: '共',
    clickRefresh: '点击刷新',
  },
  computer:{
    pcName:'计算机名',
  },
  loading: '加载中',
  selectAll: '全选',
  nologin:'未登录',
  edit: '修改',
  exportcsv:'导出CSV',
  createTime: '创建时间',
  download: '下载',
  close: '关闭',
  required: '必填',
  cancel: '取消',
  delete: '删除',
  exportLogs:'导出日志',
  deleteDirectly: '直接删除',
  actionCanNotRevertConfirm: '此操作不可撤回, 是否继续?',
  actionDeleteConfirm: '确定删除吗?',
  actionRecoveryConfirm: '确定恢复吗?',
  prompt: '提示',
  confirm: '确定',
  copy: '复制',
  copySuccess: '复制成功！',
  copyError: '复制失败！',
  showMore: '显示更多',
  username: '用户名',
  password: '密码',
  submit: '提交',
  save: '保存',
  create: '创建',
  finish: '完成',
  operationSuccess: '操作成功',
  operationFailed: '操作失败',
  operationCancelled: '操作已取消',

  notFound: '404 页面找不到',
  login: '登录',
  logout: '退出',
  yes: '是',
  no: '否',
  all: '全部',
  refresh: '刷新',
  inputRequired: '该项必填',
  selectRequired: '该项必选',
  more: '更多',
  index: '索引',
  spacename:'归属',
  updatelog: '上传日志',
  otheroplog:'访问日志',
  normal:'正常',
  downloadtime:'访问时间',
  back:'返回',
  day: '天',
  tyrAgain:'点击重试',
  downloadusermanual:'下载使用手册',
  downwinapp:'下载windows客户端',
  downandroidapp: "下载安卓客户端",
  downwinsecagent:'下载windows安全增强Agent',
  noData:'暂无数据',
  getting: '获取中...',
  freshPcInfo:'刷新设备信息',
  pcInfoRecognize:'设备信息识别:',
  formatError:'您上传的格式不符合要求',
  conditionError: '该过滤条件有问题',
  settingError2: '过滤器设置错误，请检查-2',
  approvalHint:'需在同步(摆渡)或客户端插入Ukey开启审批',
  unknownError: '未知错误',
  attention:'注意',
  operation:'操作',
  search:'搜索',
  reset:'重置',
  notAvailableUsingDefault: '未能获取设备信息，将使用默认值',
  
  // 新增通用国际化
  warning: '警告',
  info: '提示',
  success: '成功',

  
  // 新增成员表格列标题
  memberAvatar: '头像',
  memberUsername: '用户名',
  memberDepartment: '部门',
  memberRole: '成员角色',
  memberSource: '来源',
  memberCreateTime: '创建时间',
  memberOperation: '操作',
  memberCurrentUser: '当前用户',
  memberFromDepartment: '部门',
  memberManualAdd: '手动',
  memberTooltipDepartment: '来自部门绑定',
  memberTooltipManual: '手动添加',
  memberEdit: '编辑',

  // 批量操作按钮
  batchBindMember: '绑定成员',
  batchSyncMembers: '同步成员',
  batchSetRole: '批量设置角色',
  batchRemoveDepartmentBinding: '移除部门绑定',
  
  // 批量添加角色选择
  setRoleHint: '设置角色',
  
  // 统计相关
  statisticsMemberStats: '成员统计',
  statisticsTotalMembers: '总成员数',
  statisticsDepartmentMembers: '部门成员',
  statisticsManualMembers: '手动添加成员',
  statisticsBoundDepartments: '已绑定部门',
  statisticsDepartmentMemberRatio: '部门成员占比',

  // 新增 common 分支 - 修改为固定文本
  common: {
    search: '搜索',
    reset: '重置',
    cancel: '取消',
    confirm: '确定',
    total:'总数',
    retry:'重试',
    startDate:'开始时间',
    endDate:'结束时间',
    operationSuccess: '操作成功',
    operationFailed: '操作失败',
    operationComplete: '操作完成',
    syncFailed: '同步失败',
    unknownError: '未知错误',
    all: '全部',
    noError:'无错误',
    unit: '个',
    delete: '删除',
    warning: '警告',
    info: '提示',
    success: '成功',
    startAdd: '开始添加',
    startSync: '开始同步',
    batchUpdate: '批量更新',
    batchAdd: '批量添加',
    selectFirst: '请先选择要添加的部门',
    selectDept: '选择部门',
    sync: '同步',
    noDeptToAdd: '没有部门需要添加',
   
    willBatchCreateForDepts: '将为选中的部门批量创建空间',
    batchCreateSuccess: '批量创建成功',
    partialSuccess: '部分成功',
    totalCreated: '共创建空间',
    willProcessSelected: '将处理选中的部门',
    bindMember: '绑定分组成员',
    confirmBatchAddDeptMembers: '确定按照以下配置批量添加部门成员吗？',
    addMode: '添加模式',
    selectedDepts: '选中部门',
    subDeptsToAdd: '子部门',
    totalDeptsToProcess: '总处理部门',
    memberRole: '成员角色',
    processRules: '处理规则',
    addAllUsersInDept: '添加每个部门下的所有用户',
    skipExistingMembers: '跳过已存在的成员',
    eachDeptIndependent: '每个部门独立处理，互不影响',
    andMoreDepts: '...及其他部门',
    unitSpace: '个空间',
    batchCreateSuccessShort: '批量创建成功',
    willBatchCreateSelected: '将为选中的',
    unknownErrorShort: '未知错误',
    batchAddSuccess: '批量添加成功',
    batchUpdateSuccess: '批量更新成功',
    syncSuccess: '同步成功',
    noMemberAdded: '操作完成，但未添加任何成员',
    batchAddFail: '批量添加失败'
  },

  // 在 export 之前添加独立字段
  advancedOptions: '高级选项',

  // 移动存储相关
  removable: {
    storageManagement: '移动存储管理',
    storageManagementDesc: '管理连接的移动存储设备（U盘、移动硬盘等）',
    deviceList: '设备列表',
    fileBrowser: '文件浏览器',
    operationLogs: '操作日志',
    mountPoint:'挂载点',
    playAudio:'播放音频',
    playVideo:'播放视频',
    operationLogsDesc: '查看移动存储设备的操作记录',
    capacity: '容量',
    totalCapacity: "总容量",
    availableSpace: "可用空间",
    onlineDevices: "在线设备",
    noDeviceFound: '未检测到移动存储设备',
    deviceListDesc: '查看和管理所有可移动存储设备（如U盘、移动硬盘等）',
    deleteWarning:'删除警告',
    confirmDelete:'删除确认',
    deleteDirWarning:'目录删除告警',
    
    // 设备状态
    statusConnected: '已连接',
    statusDisconnected: '未连接',
    statusError: '错误',
    createDirSuccess: '目录创建成功',
    dirNameRequired: '请输入目录名',
    
    // ========== 上传相关错误提示 ==========
  uploadFailed: '上传失败',
  noUploadPermission: '无上传权限，请联系管理员',
  forbiddenExtension: '文件类型被禁止上传',
  insufficientSpace: '存储空间不足',

    // 操作类型
    opListDevices: '列出设备',
    opBrowse: '浏览目录',
    opDownload: '下载文件',
    opPreview: '预览文件',
    opRename: '重命名',
    opUpload: '上传文件',
    opDelete: '删除文件',
    
    opDescListDevices: '获取移动设备列表',
    opDescBrowse: '浏览目录内容',
    opDescDownload: '下载文件到本地',
    opDescPreview: '预览文件内容',
    opDescRename: '重命名文件/目录',
    opDescUpload: '上传文件到设备',
    opDescUploadFloader: '上传目录到设备',
    uploadFolderSuccess:'上传目录成功',
    opDescDelete: '删除文件/目录',
    
    // 文件类型
    directory: '目录',
    file: '文件',
    enterDirName:'键入目录名',
    
    // 操作按钮
    browse: '浏览',
    upload: '上传',
    download: '下载',
    preview: '预览',
    rename: '重命名',
    eject: '弹出',
    refresh: '刷新',
    open: '打开',
    goBack: '返回上级',
    backToList: '返回列表',
    
    // 提示信息
    searchDevice: '搜索设备名称',
    searchLogs: '搜索操作日志',
    filterByStatus: '按状态筛选',
    filterByOperation: '按操作类型筛选',
    filterByTime: '按时间筛选',
    selectStatus: '选择状态',
    selectOperation: '选择操作类型',
    deviceNotFound: '设备未找到',
    deviceLoadFailed: '设备加载失败',
    browseFailed: '浏览目录失败',
    downloadFailed: '下载失败',
    previewFailed: '预览失败',
    renameFailed: '重命名失败',

    refreshFailed: '刷新失败',
    
    // 确认对话框
    ejectConfirm: '确认弹出设备',
    ejectConfirmDesc: '确定要弹出此设备吗？在物理移除设备前，请确保所有文件操作已完成。',
    renameConfirm: '确认重命名',
    deleteConfirm: '确认删除',
  
    cannotPreviewDir: '不能预览目录',
    cannotPreviewThisFile: '不支持预览此类型的文件',
    downloadInstead: '改为下载',
    downloadSelected: '下载选中',
    previewSelected: '预览选中',
    selectedFiles: '已选文件',
    // 新增的预览相关提示
    cannotPreviewFile: '该文件类型不支持预览',
    fileUnaccessible: '文件无法访问',
    fileType: '文件类型',
    previewSupportedTypes: '支持预览的文件类型包括：',
    imageTypes: '图片文件（JPG, PNG, GIF, BMP, SVG等）',
    officeTypes: 'Office文档（DOC, DOCX, XLS, XLSX, PPT, PPTX等）',
    pdfType: 'PDF文档',
    textTypes: '文本文件（TXT, MD, JSON, XML, 代码文件等）',
    audioVideoTypes: '音视频文件（MP3, WAV, MP4, AVI, MKV等）',
    
    // 成功提示
    uploadSuccess: '上传成功',
    renameSuccess: '重命名成功',
    deviceRefreshed: '设备信息已刷新',
    
    // 警告提示
    nameNoChange: '文件名未改变',
    cannotDownloadDir: '不能下载目录',
    cannotPreview: '不支持预览此文件',
    selectFileFirst: '请先选择文件',
    noDeviceSelected: '未选择设备',
    unsupportedPreview: '不支持预览此类型文件',
    emptyDirectory: '目录为空',
    uploadWarning: '上传警告',
    uploadWarningDesc: '请确保目标设备有足够的存储空间，并且文件不包含敏感信息。',
    
    // 输入提示
    enterNewName: '输入新名称',
    enterTargetDir: '输入目标目录（留空为当前目录）',
    targetDirHint: '例如：/documents 或 images/photos',
    
    // 统计信息
    totalDevices: '总设备数',
    connectedDevices: '已连接设备',
    totalUsed: '总使用空间',
    totalFree: '总可用空间',
    totalSize: '总容量',
    freeSpace: '可用空间',
    totalFiles: '文件总数',
    selectedCount: '已选择 {0} 项',
    
    // 表格列
    deviceName: '设备名称',
    fileSystem: '文件系统',
    storageInfo: '存储信息',
    status: '状态',
    connectionTime: '连接时间',
    operation: '操作',
    fileName: '文件名',
    size: '大小',
    modifiedTime: '修改时间',
    type: '类型',
    operationTime: '操作时间',
    user: '用户',
    device: '设备',
    filePath: '文件路径',
    errorMessage: '错误信息',
    
    // 模态框标题
    uploadFile: '上传文件',
    uploadFolder:'上传文件夹',
    renameFile: '重命名文件',
    selectFile: '选择文件',
    clickToSelectFile: '点击选择文件',
    targetDirectory: '目标目录',
    currentDirectory: '当前目录',
    rootDirectory: '根目录',
    fileSize: '文件大小',
    renameHint: '请勿包含特殊字符：\\ / : * ? " < > |',
    
    // 其他
    refreshDevices: '刷新设备',
    viewLogs: '查看日志',
    autoRefreshNotice: '自动刷新提醒',
    autoRefreshNoticeDesc: '设备列表每30秒自动刷新一次',
    fileBrowserDesc: '浏览移动存储设备中的文件和目录',
    ejectNotImplemented: '设备弹出功能暂未实现',
    downloadPdf: '下载PDF',
    pdfPreviewHint: 'PDF文件需要下载后查看',
    startUpload: '开始上传',
    uploadToDevice: '上传到设备',
    
    // 新增字段
    filterByFileSystem: '按文件系统筛选',
    filterByPlatform: '按平台筛选',
    selectFileSystem: '选择文件系统',
    selectPlatform: '选择平台',
    showAdvancedFilters: '显示高级筛选',
    hideAdvancedFilters: '隐藏高级筛选',
    listView: '列表视图',
    gridView: '网格视图',
  
    refreshSelected: '刷新选中设备',
    clearSelection: '清除选择',
    batchRefreshSuccess: '成功刷新 {0} 个设备',
    selectDevicesFirst: '请先选择设备',
    noDevicesFound: '未找到设备',
    platformDistribution: '平台分布',
    settings: '设置',
    autoRefresh: '自动刷新',
    autoRefreshDesc: '每30秒自动刷新设备列表',
  },
  autoLogin: {
    processing: '正在自动登录中...',
    pleaseWait: '请稍候，正在处理登录请求',
    failed: '自动登录失败',
    loggingIn: '自动登录中...'
  },
  device: {
    notSupported: '当前设备不支持终端特征绑定功能',
    fetchFailed: '获取设备信息失败',
    loading: '正在获取设备信息...',
    unknown: '未知',
    usingCache: '使用缓存数据',
    // 如果需要，还可以添加更多设备相关的翻译
    macAddress: 'MAC地址',
    diskSerial: '磁盘序列号',
    deviceName: '设备名称',
    ipAddress: 'IP地址',
    osInfo: '操作系统'
  },
  secAgent: {
    installTip: '绑定终端特征或跨三层获取绑定内网IP需安装!'
  },
};

export default LangZh;